const apiUrl ='https://gobusiness-backend.herokuapp.com/api';
// const apiUrl = 'http://localhost:4000/api';

export default apiUrl;
